import API from 'services/api';

const api = new API();

// Unwrap the shared `{status, value}` envelope: a non-zero status rejects with the error payload.
const fetchValue = (url, options = {}) =>
    new Promise((resolve, reject) => {
        api.getJson(url, { credentials: 'include', ...options })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });

// Keyed by ad network name and already ordered by display name, so no sorting is needed here.
export const getAdNetworks = () => fetchValue('/api/adnetworks').then(value => Object.values(value.adnetworks || {}));

export const getApps = () => fetchValue('/api/users/self/apps');

export const getPlatforms = () => fetchValue('/api/devices');

export const getUploadedReports = () =>
    fetchValue('/manual-upload/api/uploaded_reports', { disableBrowserCache: true });

// The endpoint dispatches on the browser-reported Content-Type and parses the body itself, so the
// file goes out raw rather than wrapped in a FormData. Returns the envelope unwrapped: a rejected
// upload still answers 200, with the reason in `value.result`.
export const submitReport = (file, queryString) =>
    api.getJson(`/manual-upload/api/submit?${queryString}`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': file.type },
        body: file,
    });

export const deleteReport = publicId =>
    fetchValue('/manual-upload/api/delete', { method: 'POST', body: { public_id: publicId } });
